import { t } from '@lingui/macro';
import { FilterContainer } from '../../page-framework';
import { TimeRangeFilter, UserFilter } from '../../filters';
import { AdminPages, buildPageId } from '../AdminLinkUtils';
import AdminPage from '../AdminPage';
import AuditActivityListPanel from './AuditActivityListPanel';

const functionName = AdminPages.AuditActivities;

export default function AuditActivityList() {
    return (
        <AdminPage
            title={t`Audit Activities`}
            pageId={buildPageId(functionName)}
            filterElement={
                <FilterContainer showFilterMenu={false}>
                    <TimeRangeFilter required options={{ realTime: true }} />
                    <UserFilter required />
                </FilterContainer>
            }
            actions={<></>}
        >
            <AuditActivityListPanel />
        </AdminPage>
    );
}
